import currencyFormat from "./currencyFormat";

export default function currencySymbol() {
  const value = 0;

  const symbol = currencyFormat(value).split("0");

  return symbol[0];
}
